import {CenterHero} from "../../blocks/hero/Hero";
import {Footer} from "../../blocks/footer/Footer";
import {useEffect} from "react";

export default function ImpressPage(){
    return (
        <>
            <CenterHero
                url={'/benefitshare/img/headerbg3.jpg'}
                megaphone={'Shaping success, sharing great ideas'}
                titles={['Impresszum']}
                fill={'#f0f2f8'}
            ></CenterHero>
            <section id={'newsletter'}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 last-paragraph-no-margin"
                             data-anime={JSON.stringify({
                                 "el": "childs",
                                 "translateY": [50, 0],
                                 "opacity": [0, 1],
                                 "duration": 1200,
                                 "delay": 0,
                                 "staggervalue": 150,
                                 "easing": "easeOutQuad"
                             })}>
                            <h5 className="alt-font fw-600 text-dark-gray">BeneFit SHARE conference</h5>
                            <p>
                                Szervezet neve:<br/>
                                KLUB REKREÁCIÓ Sport-, és Rendezvényszervező Korlátolt Felelősségű Társaság
                            </p>
                            <br/>
                            <p>
                                Cím:<br/>
                                1052 Budapest, Apáczai Csere János u. 5. 1. em. 3/B.
                            </p>
                            <br/>
                            <p>
                                E-mail:<br/>
                                <a href={'mailto:info@benefitprize.hu'}>info@benefitprize.hu</a>
                            </p>
                            <br/>
                            <p>
                                Internet:<br/>
                                <a href={'https://share.benefitprize.hu/'}>https://share.benefitprize.hu/</a></p>
                            <br/>
                            <p>
                                A céget bejegyző hatóság:<br/>
                                Fővárosi Törvényszék
                            </p>
                            <br/>
                            <p>
                                Cégjegyzékszám:<br/>
                                01 09 723671
                            </p>
                            <br/>
                            <p>
                                Adószám:<br/>
                                13206828-2-41
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <Footer></Footer>
        </>
    )
}